module.exports = __webpack_public_path__ + "static/img/kanban07.df20ea3d.png";